export default "__VITE_ASSET__CuhHpJjj__"